export default __webpack_public_path__ + "static/media/98f49ee410193c84.2088fdd845acd90a0b7cf7c28db25e00.svg";